<template>
  <div class="container">
    <div class="page-header">
      主题管理<button type="button" @click="showForm({
        taxonomy: 'theme'
    })" class="btn btn-xs btn-primary">添加主题</button>
    </div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>主题名称</th>
          <th>介绍</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in theme" track-by="id">
          <td>{{item.title}}</td>
          <td>{{item.intro}}</td>
          <td>
            <div class="btn-group btn-group-xs">
              <button type="button" @click="showForm(item)" class="btn btn-primary">修改</button>
              <button type="button" class="btn btn-primary" @click="remove(item.id)">删除</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <aside :show.sync="isShowForm" placement="right" header="标签" :width="400">
      <form class="form-horizontal">
        <div class="page-header">
          {{ form.taxonomy === 'theme' ? '主题' : '城区'}}
          {{ form.parentTitle && '父级:' + form.parentTitle || ''}}
        </div>
        <div class="form-group">
          <label for="name" class="col-xs-3 control-label">名称</label>
          <div class="col-xs-9">
            <input type="text" id="name" v-model="form.title" class="form-control">
          </div>
        </div>

        <div class="form-group">
          <label for="name1" class="col-xs-3 control-label">介绍</label>
          <div class="col-xs-9">
            <textarea id="name1" v-model="form.intro" cols="30" rows="3" class="form-control"></textarea>
          </div>
        </div>

        <div class="from-group">
          <div class="col-xs-9 col-xs-offset-3">
            <button class="btn btn-primary" type="button" @click="click(submit)($event, form)">提交</button>
          </div>
        </div>
      </form>
    </aside>
  </div>
</template>

<script>
  import { aside } from 'vue-strap'
  import config from '../libs/config'
  import utils from '../libs/utils'
  import { pick } from 'lodash'
  export default {
    data () {
      return {
        theme: [],
        area: [],
        form: {},
        isShowForm: false
      }
    },
    components: {
      aside
    },
    methods: {
      showForm (current = {}, parent = {}) {
        this.form = Object.assign({}, current)
        this.form.parentTitle = parent.title
        this.form.parent = parent.id || 0

        this.isShowForm = true
      },
      remove (id) {
        if (window.confirm('确定删除？')) {
          return this.$http.delete(config.apiWe + '/product/term/' + id)
            .then(this.fetchTags)
        }
      },
      submit () {
        let data = pick(this.form, ['title', 'taxonomy', 'intro', 'parent'])
        let xhr
        if (this.form.id) {
          xhr = this.$http.put(config.apiWe + '/product/term/' + this.form.id, data)
        } else {
          xhr = this.$http.post(config.apiWe + '/product/term', data)
        }
        return xhr.then(({data}) => {
          this.fetchTags()
          this.isShowForm = false
        })
      },
      fetchTags () {
        return this.$http.get(config.apiWe + '/product/term')
          .then(({data}) => {
            this.theme = data.theme
            this.area = data.area
          })
      },
      click: utils.click
    },
    route: {
      data ({next}) {
        this.fetchTags()
          .then(next)
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** Tags.vue?0f857422
 **/